





















































import {
  defineComponent,
  ref,
  computed,
  useFetch,
  useContext,
  useRoute,
  useRouter
} from '@nuxtjs/composition-api';
import { usePartFinderStore } from '~/modules/part-finder/stores/partFinder';
import type { Model } from '~/modules/part-finder/types';
import { storeToRefs } from 'pinia';
import { SfHeading, SfBreadcrumbs } from '@storefront-ui/vue';
import SkeletonLoader from 'components/theme/SkeletonLoader.vue';

export default defineComponent({
  name: 'PartFinderModels',
  components: {
    SfHeading,
    SfBreadcrumbs,
    SkeletonLoader
  },
  setup () {
    const store = usePartFinderStore();
    const route = useRoute();
    const term = ref<string>(route.value.query.term ? String(route.value.query.term) : '');
    const filteredModels = ref<Model[]>([]);
    const { setBrand, setFinder, loadFinders } = store;
    const { finders, selectedFinder, models, selectedBrand, brands, brandsLoading, modelsLoading } = storeToRefs(store);


    const { app, error: nuxtError } = useContext();
    const i18n = app?.i18n;
    const localeRoute = computed(() => app?.localeRoute || ((route: any) => route));

    const breadcrumbs = ref([
      { text: i18n?.t('Home') || 'Home', link: localeRoute.value({ name: 'home' }).fullPath },
      { text: i18n?.t('part-finder.spare-parts') || 'Maskiner', link: localeRoute.value({ name: 'part-finder' }).fullPath }
    ]);

    const router = useRouter();
    const updateHistory = () => {
      if (!process.client) return;
      const queryTerm = term.value.trim();

      if (queryTerm === '' && route.value.query.term) {
        window.history.replaceState({}, '', router.resolve({query: {}}).href);
      } else if (queryTerm !== route.value.query.term) {
        const query = queryTerm ? {term: queryTerm} : {};
        window.history.replaceState({}, '', router.resolve({query}).href);
      }
    }

    function filterModels () {

      if (term.value.length < 2 || !models.value?.length) {
        filteredModels.value = models.value;
      }
      const searchTerm = term.value.toLowerCase();
      filteredModels.value = models.value.filter((model: Model) =>
        model.name.toLowerCase().includes(searchTerm)
      );

      updateHistory();
    }


    useFetch(async () => {
      if (!finders.value.length) {
        await loadFinders();
      }
      const finder = finders.value.find(b => b.slug === route.value.params.finder);
      if (finder) {
        await setFinder(finder);
        breadcrumbs.value.push({
          text: finder.name,
          link: localeRoute.value({ name: 'part-finder-finders', params: { finder: finder.slug } }).fullPath});
      }
      const brand = brands.value.find(b => b.slug === route.value.params.brand);
      if (brand) {
        await setBrand(brand);
        breadcrumbs.value.push({
          text: brand.name,
          link: localeRoute.value(
            {
              name: 'part-finder-models', params: {
                  finder: finder.slug,
                  brand: brand.slug
              }
            })
            .fullPath
        });
      } else {
        nuxtError({ statusCode: 404 });
      }
      filterModels();
    });

    const loading = computed(() => brandsLoading.value || modelsLoading.value);
    const searchPlaceholder = computed(() => {
      return i18n?.t('part-finder.searchPlaceholder') || 'Søk...';
    });

    return {
      term,
      breadcrumbs,
      finder: selectedFinder,
      brand: selectedBrand,
      models: filteredModels,
      loading,
      filterModels,
      searchPlaceholder
    }
  },
  head () {
    return {
      title: this.brand ? this.brand['name'] : ''
    }
  }
});
